import { RadioGroupProps } from '@mui/material';
import { StyledRadioGroup } from './RadioGroup.styled';

export default function RadioGroup({ children, ...props }: RadioGroupProps) {
  return <StyledRadioGroup {...props}>{children}</StyledRadioGroup>;
}
